import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import { useEmpresa } from '../../../contexts/EmpresaContext';

export default function FinanceiroPage() {
  const { empresaSelecionada } = useEmpresa();
  const [selectedPeriod, setSelectedPeriod] = useState('mes');
  const [activeTab, setActiveTab] = useState('compra');
  const navigate = useNavigate();

  // Recarregar dados quando a empresa mudar
  useEffect(() => {
    carregarDadosEmpresa();
  }, [empresaSelecionada.id]);

  const carregarDadosEmpresa = () => {
    // Aqui você carregaria os dados reais da empresa selecionada
    console.log('Carregando dados da empresa:', empresaSelecionada.id, empresaSelecionada.nome);
    // Exemplo: buscar dados da API baseado no empresaSelecionada.id
  };

  const statsCards = [
    {
      title: 'Saldo Total de Pontos',
      value: '125.450',
      change: '+8.5%',
      changeType: 'positive',
      icon: 'ri-coin-line',
      color: 'blue'
    },
    {
      title: 'Pontos Distribuídos (Mês)',
      value: '45.230',
      change: '+12.3%',
      changeType: 'positive',
      icon: 'ri-send-plane-line',
      color: 'emerald'
    },
    {
      title: 'Valor Investido',
      value: 'R$ 18.450,00',
      change: '+5.2%',
      changeType: 'positive',
      icon: 'ri-money-dollar-circle-line',
      color: 'orange'
    },
    {
      title: 'Compras Pendentes',
      value: '3',
      change: '-2',
      changeType: 'positive',
      icon: 'ri-time-line',
      color: 'slate'
    }
  ];

  const journeySteps = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'Compra de Pontos',
      description: 'Adquira créditos para sua campanha',
      items: ['Escolha o pacote', 'Realize o pagamento', 'Receba os pontos'],
      path: '/admin/incentivo/compra-pontos',
      color: 'bg-gradient-to-br from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-send-plane-line',
      title: 'Distribuição de Pontos',
      description: 'Distribua pontos aos participantes',
      items: ['Selecione participantes', 'Defina valores', 'Confirme distribuição'],
      path: '/admin/incentivo/conciliacao-contabil',
      color: 'bg-gradient-to-br from-green-500 to-green-600'
    },
    {
      icon: 'ri-gift-line',
      title: 'Resgate de Prêmios',
      description: 'Participantes trocam pontos por prêmios',
      items: ['Catálogo disponível', 'Escolha do prêmio', 'Confirmação'],
      path: '/admin/incentivo/recompensas',
      color: 'bg-gradient-to-br from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Extrato de Pontos',
      description: 'Acompanhe movimentações',
      items: ['Histórico completo', 'Filtros avançados', 'Exportação'],
      path: '/admin/incentivo/extrato-pontos',
      color: 'bg-gradient-to-br from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Auditoria',
      description: 'Verifique todas as operações',
      items: ['Logs detalhados', 'Rastreabilidade', 'Conformidade'],
      path: '/admin/auditoria/dashboard',
      color: 'bg-gradient-to-br from-red-500 to-red-600'
    }
  ];

  const recentTransactions = [
    {
      id: 1,
      type: 'compra',
      description: 'Compra de 50.000 pontos',
      value: '+ 50.000',
      amount: 'R$ 15.000,00',
      date: '2024-01-15',
      status: 'Concluído'
    },
    {
      id: 2,
      type: 'distribuicao',
      description: 'Distribuição - Campanha Vendas Q4',
      value: '- 12.500',
      amount: 'R$ 3.750,00',
      date: '2024-01-14',
      status: 'Processando'
    },
    {
      id: 3,
      type: 'compra',
      description: 'Compra de 25.000 pontos',
      value: '+ 25.000',
      amount: 'R$ 7.500,00',
      date: '2024-01-12',
      status: 'Concluído'
    },
    {
      id: 4,
      type: 'distribuicao',
      description: 'Distribuição - Meta Mensal',
      value: '- 8.900',
      amount: 'R$ 2.670,00',
      date: '2024-01-10',
      status: 'Concluído'
    }
  ];

  const distributionData = [
    { campaign: 'Vendas Q4 2024', distributed: 12500, participants: 45, percentage: 35 },
    { campaign: 'Meta Mensal Dezembro', distributed: 8900, participants: 32, percentage: 25 },
    { campaign: 'Indicação de Clientes', distributed: 15600, participants: 67, percentage: 40 }
  ];

  const getStatColor = (color: string) => {
    const colors = {
      blue: 'bg-blue-600',
      emerald: 'bg-emerald-500',
      orange: 'bg-orange-500',
      slate: 'bg-slate-600'
    };
    return colors[color as keyof typeof colors];
  };

  const getStepIconBg = (color: string) => {
    const baseColors = {
      blue: 'bg-blue-500',
      emerald: 'bg-emerald-500',
      orange: 'bg-orange-500',
      slate: 'bg-slate-500',
      purple: 'bg-purple-500',
      indigo: 'bg-indigo-500'
    };
    return baseColors[color as keyof typeof baseColors];
  };

  const getTransactionIcon = (type: string) => {
    return type === 'compra' ? 'ri-add-circle-line' : 'ri-send-plane-line';
  };

  const getTransactionColor = (type: string) => {
    return type === 'compra' ? 'text-emerald-600' : 'text-blue-600';
  };

  return (
    <Layout>
      <div className="space-y-8">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Gestão Financeira de Pontos</h1>
            <p className="text-gray-600 mt-1">Gerencie compras, distribuição e acompanhe o fluxo de pontos</p>
          </div>
          <div className="flex items-center space-x-3">
            <select
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-8"
            >
              <option value="semana">Esta Semana</option>
              <option value="mes">Este Mês</option>
              <option value="trimestre">Este Trimestre</option>
              <option value="ano">Este Ano</option>
            </select>
            <button 
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
              onClick={() => navigate('/admin/incentivo/compra-pontos')}
            >
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-cart-line"></i>
                </div>
                <span>Comprar Pontos</span>
              </div>
            </button>
          </div>
        </div>

        {/* Stats Cards - Moved above Journey */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {statsCards.map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-2">{stat.value}</p>
                  <div className="flex items-center mt-2">
                    <span className={`text-sm font-medium ${stat.changeType === 'positive' ? 'text-emerald-600' : 'text-red-600'}`}>
                      {stat.change}
                    </span>
                    <span className="text-sm text-gray-500 ml-1">vs período anterior</span>
                  </div>
                </div>
                <div className={`w-12 h-12 rounded-lg ${getStatColor(stat.color)} flex items-center justify-center`}>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${stat.icon} text-white text-xl`}></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Jornada de Gestão de Pontos */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-900 mb-2 text-left">Jornada de Gestão de Pontos</h2>
            <p className="text-gray-600 text-left">Siga estas etapas para gerenciar completamente o ciclo de pontos</p>
          </div>

          {/* Journey Steps - Single Row */}
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            {journeySteps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step Card */}
                <div className="bg-white border-2 border-gray-200 rounded-lg p-4 hover:shadow-md transition-all duration-300 hover:border-blue-300 h-full flex flex-col">
                  {/* Step Number and Icon */}
                  <div className="flex items-center justify-center mb-4">
                    <div className={`w-12 h-12 rounded-full ${step.color} flex items-center justify-center relative z-10`}>
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${step.icon} text-white text-xl`}></i>
                      </div>
                    </div>
                  </div>

                  {/* Step Info */}
                  <div className="text-center mb-4 flex-shrink-0">
                    <div className="text-xs font-medium text-gray-500 mb-1">ETAPA {index + 1}</div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.description}</p>
                  </div>

                  {/* Step Details */}
                  <div className="space-y-2 flex-grow mb-4">
                    {step.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="flex items-start space-x-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2 flex-shrink-0"></div>
                        <span className="text-xs text-gray-600">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* Action Button */}
                  <button
                    onClick={() => navigate(index === 1 ? '/admin/incentivo/distribuicao' : index === 4 ? '/admin/incentivo/conciliacao-contabil' : step.path)}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {index === 0 ? 'Comprar' : index === 1 ? 'Distribuir' : index === 3 ? 'Consultar' : index === 4 ? 'Verificar' : 'Acessar'}
                  </button>
                </div>

                {/* Arrow (except for last item) */}
                {index < journeySteps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 -right-3 z-20">
                    <div className="w-6 h-6 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-gray-400 text-sm"></i>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Conteúdo das Abas */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Gráfico de Distribuição */}
          <div className="lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Distribuição de Pontos por Campanha</h3>
              <div className="flex items-center space-x-2">
                <button className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded-lg cursor-pointer whitespace-nowrap">
                  Distribuição
                </button>
                <button className="px-3 py-1 text-sm text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer whitespace-nowrap">
                  Saldo
                </button>
              </div>
            </div>
            
            <div className="space-y-4">
              {distributionData.map((item, index) => (
                <div key={index} className="p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-medium text-gray-900">{item.campaign}</h4>
                    <span className="text-sm text-gray-600">{item.distributed.toLocaleString()} pontos</span>
                  </div>
                  <div className="flex items-center space-x-4 mb-2">
                    <span className="text-sm text-gray-600">
                      <div className="w-4 h-4 inline-flex items-center justify-center mr-1">
                        <i className="ri-group-line"></i>
                      </div>
                      {item.participants} participantes
                    </span>
                    <span className="text-sm text-gray-600">{item.percentage}% do total</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-blue-600 h-2 rounded-full" 
                      style={{ width: `${item.percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-information-line text-white"></i>
                  </div>
                </div>
                <div>
                  <h4 className="font-medium text-blue-900">Resumo do Período</h4>
                  <p className="text-sm text-blue-700">Total de 37.000 pontos distribuídos entre 144 participantes em 3 campanhas ativas</p>
                </div>
              </div>
            </div>
          </div>

          {/* Transações Recentes */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Transações Recentes</h3>
              <div className="flex items-center space-x-2">
                <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm pr-8">
                  <option>Todas</option>
                  <option>Compras</option>
                  <option>Distribuições</option>
                  <option>Resgates</option>
                </select>
                <button className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer whitespace-nowrap">
                  Ver todas
                </button>
              </div>
            </div>
            <div className="space-y-4">
              {recentTransactions.map((transacao, index) => (
                <div key={index} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                  <div className="flex items-center space-x-4">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      transacao.type === 'compra' ? 'bg-blue-100' :
                      transacao.type === 'distribuicao' ? 'bg-green-100' :
                      'bg-orange-100'
                    }`}>
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={`${
                          transacao.type === 'compra' ? 'ri-shopping-cart-line text-blue-600' :
                          transacao.type === 'distribuicao' ? 'ri-send-plane-line text-green-600' :
                          'ri-gift-line text-orange-600'
                        }`}></i>
                      </div>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{transacao.description}</p>
                      <p className="text-sm text-gray-600">{transacao.date}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className={`font-semibold ${
                      transacao.type === 'compra' ? 'text-blue-600' :
                      transacao.type === 'distribuicao' ? 'text-green-600' :
                      'text-orange-600'
                    }`}>
                      {transacao.value}
                    </p>
                    <p className="text-sm text-gray-500">{transacao.amount}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Widgets de Informações */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Widget Fluxo de Caixa */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="font-semibold text-gray-900">Fluxo de Pontos</h4>
              <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-line-chart-line text-blue-600"></i>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Entrada</span>
                <span className="text-sm font-medium text-emerald-600">+75.000 pts</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Saída</span>
                <span className="text-sm font-medium text-red-600">-37.000 pts</span>
              </div>
              <div className="border-t pt-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium text-gray-900">Saldo Líquido</span>
                  <span className="text-sm font-bold text-blue-600">+38.000 pts</span>
                </div>
              </div>
            </div>
          </div>

          {/* Widget Eficiência */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="font-semibold text-gray-900">Eficiência</h4>
              <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-dashboard-line text-emerald-600"></i>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Taxa de Utilização</span>
                <span className="text-sm font-medium text-gray-900">74%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div className="bg-emerald-500 h-2 rounded-full" style={{ width: '74%' }}></div>
              </div>
              <div className="flex justify-between items-center text-xs text-gray-500">
                <span>Pontos distribuídos / Pontos comprados</span>
              </div>
            </div>
          </div>

          {/* Widget Custo Médio */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="font-semibold text-gray-900">Custo Médio</h4>
              <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-orange-600"></i>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Por Ponto</span>
                <span className="text-sm font-medium text-gray-900">R$ 0,30</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Por Participante</span>
                <span className="text-sm font-medium text-gray-900">R$ 128,50</span>
              </div>
              <div className="border-t pt-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Economia vs. Mês Anterior</span>
                  <span className="text-sm font-medium text-emerald-600">-8.5%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
